import React, { Component } from 'react';
import StudentOverviewFilter from '../../StudentService/StudentOverview/StudentOverviewFilter';

class SemesterTransfer extends Component {
    render() {
        return (
            <div>
                <h1>Prebacivanje semestara</h1>
                <StudentOverviewFilter
                    removeHeader
                    transferSemester
                />
            </div>
        );
    }
}

export default SemesterTransfer;



// WEBPACK FOOTER //
// ./src/views/Admin/Transfer/SemesterTransfer.js